import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

export interface IconTileProps extends HTMLAttributes<HTMLSpanElement> {
	/**
	 * Заливка выбирается от подложки, а не от смысла: на белой карточке плитка
	 * серая, на серой плашке — белая. Это единственный способ удержать её
	 * видимой, раз в системе нет рамок.
	 */
	tone?: "sunken" | "card" | "brand";
	size?: 32 | 40 | 48;
	children?: ReactNode;
}

/** Квадратная подложка под иконку: 40×40, r10 — на шаг туже карточки. */
export function IconTile({
	tone = "sunken",
	size = 40,
	className,
	children,
	...rest
}: IconTileProps) {
	return (
		<span
			className={cn(
				"inline-flex shrink-0 items-center justify-center rounded-control text-fg",
				size === 32 && "size-8",
				size === 40 && "size-10",
				size === 48 && "size-12",
				tone === "sunken" && "bg-sunken",
				tone === "card" && "bg-card",
				tone === "brand" && "bg-chip-brand",
				className,
			)}
			{...rest}
		>
			{children}
		</span>
	);
}
